import { Component, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Header } from './components/shared/header/header';
import { AppFooter } from './app-footer';
import { ScrollToTopComponent } from './components/shared/scroll-to-top/scroll-to-top';
import { FloatingVideoComponent } from './components/shared/floating-video/floating-video';
import { FloatingWhatsappComponent } from './components/shared/floating-whatsapp/floating-whatsapp';
import { FloatingCallComponent } from './components/shared/floating-call/floating-call';
import { FloatingAppointmentComponent } from './components/shared/floating-appointment/floating-appointment';
import { AppointmentModal } from './components/shared/appointment-modal/appointment-modal';
import { AppointmentService } from './services/appointment.service';
// import { FloatingProductCardComponent } from './components/shared/floating-product-card/floating-product-card';

import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Header, AppFooter, CommonModule, ScrollToTopComponent, FloatingVideoComponent, FloatingWhatsappComponent, FloatingCallComponent, FloatingAppointmentComponent, AppointmentModal],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('height-ecommerce');
  showHeaderFooter = false;
  showFloatingComponents = true;
  
  // Appointment modal state
  isAppointmentModalOpen = false;

  constructor(
    private router: Router,
    private appointmentService: AppointmentService
  ) {
    // Listen to route changes to determine when to show header/footer
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Hide header/footer for login, register, and admin pages (home should show)
      const isAuthPage = event.url.includes('/login') || event.url.includes('/register') || event.url.includes('/support');
      const isAdminPage = event.url.includes('/admin');
      this.showHeaderFooter = !isAuthPage && !isAdminPage;
      // Hide floating components (WhatsApp, call, scroll-to-top) for admin and auth pages
      this.showFloatingComponents = !isAdminPage && !isAuthPage;
      console.log('Route changed:', event.url, 'Show header/footer:', this.showHeaderFooter, 'Show floating components:', this.showFloatingComponents);
    });
    
    // Initial check for current route
    const currentUrl = this.router.url;
    const isAuthPage = currentUrl.includes('/login') || currentUrl.includes('/register') || currentUrl.includes('/support');
    const isAdminPage = currentUrl.includes('/admin');
    this.showHeaderFooter = !isAuthPage && !isAdminPage;
    // Hide floating components (WhatsApp, call, scroll-to-top) for admin and auth pages
    this.showFloatingComponents = !isAdminPage && !isAuthPage;
    
    // Listen to appointment service for floating button clicks
    this.appointmentService.openModal$.subscribe(() => {
      this.openAppointmentModal();
    });
  }

  // Appointment modal methods
  openAppointmentModal(): void {
    this.isAppointmentModalOpen = true;
  }

  closeAppointmentModal(): void {
    this.isAppointmentModalOpen = false;
  }

}
